import { useEffect } from "react";
import { MarketMapper } from "../market-mapper";
import { PerpMarketProgram } from "../programs/perp-market";
import { useMarkets } from "@/domains/markets";
import { debug } from "@/lib/debug";

/**
 * Hook to initialize market configurations for Nordex perpetual markets
 * 
 * Price updates are now handled by the backend WebSocket, which broadcasts
 * real-time prices from the configured market data provider (CoinAPI or Massive).
 * 
 * This hook only initializes market metadata and mappings.
 */
export const useMarketPriceSync = () => {
  const { markets } = useMarkets();

  // Initialize dynamic markets when markets are loaded from API
  useEffect(() => {
    if (markets.length > 0) {
      // Initialize PerpMarketProgram with dynamic markets from API
      PerpMarketProgram.initializeDynamicMarkets(
        markets.map(m => ({
          symbol: m.symbol,
          baseSymbol: m.baseSymbol,
          quoteSymbol: m.quoteSymbol,
          binanceSymbol: m.providerSymbol || m.binanceSymbol, // Support both old and new field names during migration
        }))
      );
      
      // Initialize MarketMapper with dynamic mappings
      MarketMapper.initializeDynamicMappings(markets);
      
      debug.log('useMarketPriceSync', `Initialized ${markets.length} markets`);
    }
  }, [markets]);

  // Price updates are handled by backend WebSocket
  // The backend broadcasts prices from the active provider (CoinAPI/Massive)
  // which are then processed by the WsHub and distributed to components

  return {
    isConnected: markets.length > 0,
  };
};

